<template>
  <Photos year="2019" :min-date="1552348800" :max-date="1552694400" date-text="March 12&ndash;16" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
